module.exports = __webpack_public_path__ + "static/microsoft-todo-e806f3e989d22314e3f19d986c96dc7c.svg";